import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Stats } from "./components/Stats";
import { Benefits } from "./components/Benefits";
import { Process } from "./components/Process";
import { Testimonials } from "./components/Testimonials";
import { Objections } from "./components/Objections";
import { WhatsAppCTA } from "./components/WhatsAppCTA";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import Admin from "./pages/Admin";
import { PartnerProvider } from "./PartnerContext";
import { HERO_VARIANTS } from "./data";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Funnel = () => {
  return (
    <>
      <Navbar />
      <main>
        <Hero config={HERO_VARIANTS.default} />
        <Marquee />
        <Process />
        <WhatsAppCTA testid="cta-mid-whatsapp" />
        <Benefits />
        <Stats />
        <Testimonials />
        <WhatsAppCTA
          testid="cta-soft-whatsapp"
          title="Überzeugt? Dann lass uns starten."
          subtitle="Schreib uns kurz auf WhatsApp – wir sagen dir sofort, ob in deiner Region Aufträge frei sind."
          label="Jetzt auf WhatsApp starten"
        />
        <Objections />
        <FAQ />
        <FinalCTA />
        <Footer />
      </main>
      <WhatsAppFloat />
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-[#070A11]">
      <BrowserRouter>
        <PartnerProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Funnel />} />
            <Route path="/tiktok" element={<Funnel />} />
            <Route path="/v2" element={<Navigate to="/" replace />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </PartnerProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
